import { render, staticRenderFns } from "./my-team.vue?vue&type=template&id=027984d8&"
import script from "./my-team.vue?vue&type=script&lang=js&"
export * from "./my-team.vue?vue&type=script&lang=js&"
import style0 from "./my-team.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports